._tooltip-content__title_zkw1e_1 {
  padding-bottom: 6px; }

._tooltip-content__link_zkw1e_4 {
  padding-top: 6px; }

._tooltipContainer_zkw1e_7 {
  width: 100%; }
